import React, { useState, useEffect } from "react";
import Search from "../../images/search.svg";
import "./TableFilterHeader.scss";
import { Box, Typography, TextField, Button, IconButton } from "@mui/material";
import { useSelector } from "react-redux";

function TableFilterHeader({ handleSearch, createAllowed, setOpen, isAdmin, setOpenMoneyGramModel, pageName, placeholder }) {
  const [searchText, setSearchText] = useState("");
  let configVariables = useSelector((state) => state.config.baseConfig);

  const handleInputChange = (event) => {
    const inputText = event.target.value;
    setSearchText(inputText);
  };

  const handleKeyDown = async(event) => {
    if (event.key === 'Enter') {
    handleSearch(searchText);
  }
  };

  useEffect(() => {
    handleSearch("");
  }, []);

  return (
    <Box className="options-container">
      <Box className="search-container">
      <TextField
          placeholder={placeholder ? placeholder : "Search Customer"}
          value={searchText}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          variant="standard"
          fullWidth
          InputProps={{
            disableUnderline: true, 
            sx: {
              borderRadius: '33px',
              color: '#000',
            },
            endAdornment: (
              <IconButton 
                onClick={() => handleSearch(searchText)} 
                sx={{ 
                  padding: "5px", 
                  // marginRight: "5px" 
                }}
              >
                <img 
                  src={Search} 
                  alt="Search Icon" 
                  style={{ width: "20px", height: "20px" }} 
                  loading="lazy" 
                />
              </IconButton>
            ),
          }}
          sx={{
            '& .MuiInputBase-root': {
            },
            '& .MuiInputBase-input': {
              fontSize: '14px',
            },
          }}
        />
      </Box>
      
      {configVariables.showAddMoneygramButton && (isAdmin === "true" || (createAllowed && createAllowed == 1 && pageName === "CRM")) && (
        <Button
          className="new-user-button"
          onClick={()=>setOpenMoneyGramModel(true)}
          sx={{
            borderRadius: '33px',
            backgroundColor: '#3bc97b',
            border: 'none',
            display: 'flex',
            color: 'white',
            alignItems: 'center',
            padding: '0px 17px 0px 25px',
            height: '40px',
            transition: 'background-color 0.3s ease',
            '&:hover': {
              backgroundColor: '#45d488',
            },
          }}
        >
          <Typography>Add MoneyGram User</Typography>
          <Box>+</Box>
        </Button>
      )}

      {/* This button will trigger the offcanvas from bootstrap  */}
      {(isAdmin === "true" || (createAllowed && createAllowed == 1)) && (
        <Button
          className="new-user-button"
          onClick={setOpen}
          sx={{
            borderRadius: '33px',
            backgroundColor: '#3bc97b',
            border: 'none',
            display: 'flex',
            color: 'white',
            alignItems: 'center',
            padding: '0px 17px 0px 25px',
            height: '40px',
            transition: 'background-color 0.3s ease',
            '&:hover': {
              backgroundColor: '#45d488',
            },
          }}
        >
          <Typography sx={{textTransform: "none"}}>Add New</Typography>
          <Box>+</Box>
        </Button>
      )}

    </Box>
  );
}

export default TableFilterHeader;
